import React from 'react';

const GmapContainer = ({ children }: { children: React.ReactNode }) => {
  return <div className="absolute inset-0">{children}</div>;
};

export default GmapContainer;
